const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/pages/appointment/components/GoToAppointmentListButton.tsx';
import { Button } from '@mui/material';
import * as React from 'react';
import textMap from '../translations';
import { useIntl } from 'react-intl';
import { cx } from '@emotion/css';
import { useHistory } from 'react-router';
import { goToAppointments } from 'App/utils/history';

type GoToAppointmentListButtonProps = {
    className?: string;
};

export const GoToAppointmentListButton = (props: GoToAppointmentListButtonProps) => {
    const { formatMessage } = useIntl();
    const history = useHistory();

    const handleClick = () => {
        goToAppointments(history);
    };

    return (
        <Button className={cx(props.className)} variant={'contained'} color={'primary'} onClick={handleClick}>
            {formatMessage(textMap.myAppointments)}
        </Button>
    );
};
